import { getFormData } from "./getFormData";

export const formHandler = () => {
  const forms = document.querySelectorAll("[data-form-wrapper]");

  if (!forms.length) return;

  forms.forEach((formWrapper) => {
    const form =
      formWrapper.tagName === "FORM"
        ? formWrapper
        : formWrapper.querySelector("form");
    const submitBtn = formWrapper.querySelector("[data-form-submit]");

    if (!form) {
      console.error("Форма не найдена внутри data-form-wrapper!");
      return;
    }

    submitBtn.addEventListener("click", (e) => {
      e.preventDefault();

      if (submitBtn.disabled) return; // 💡 Блокируем повторные клики

      submitBtn.disabled = true; // 💡 Отключаем кнопку, пока идёт запрос
      console.log("Форма отправляется...");

      try {
        const formData = getFormData(form);
        console.log([...formData.entries()]); // Проверяем, отправляется ли файл
        fetch(window.location.origin + "/wp-json/form/submit", {
          method: "POST",
          body: formData,
        })
          .then((response) => response.json())
          .then((data) => {
            if (data.success) {
              alert("Дякуємо, ми з вами зв'яжемося!");
            } else {
              alert("Виникла помилка!");
            }
          })
          .catch((error) => {
            console.error("Ошибка при отправке:", error);
            alert("Виникла помилка!");
          })
          .finally(() => {
            submitBtn.disabled = false; // 🔄 Разблокируем кнопку после запроса
          });
      } catch (error) {
        console.error("Ошибка при обработке формы:", error);
        submitBtn.disabled = false;
      }
    });
  });
};
